import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { useAuth } from '../App';

const PaymentCancel = () => {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900 flex items-center justify-center">
        <div className="text-white text-2xl">Please log in to continue</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900">
      {/* Navigation */}
      <nav className="bg-black/20 backdrop-blur-lg border-b border-white/10 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-2">
              <div className="text-3xl">⚡</div>
              <span className="text-2xl font-bold text-white">D.C. Technology Corp.</span>
            </div>
            
            <div className="flex items-center space-x-4">
              <Link to="/dashboard">
                <Button variant="outline" className="border-white/50 text-white bg-white/10">
                  Dashboard
                </Button>
              </Link>
              
              <Link to="/profile">
                <Button variant="outline" className="border-white/50 text-white bg-white/10">
                  Profile
                </Button>
              </Link>
              
              <Button 
                onClick={logout}
                variant="outline" 
                className="border-red-400/50 text-red-400 bg-red-500/20"
              >
                Logout
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Card className="bg-white/10 backdrop-blur-lg border-white/20">
          <CardContent className="p-8 text-center">
            <div className="rounded-full h-16 w-16 bg-orange-500 mx-auto mb-6 flex items-center justify-center">
              <span className="text-3xl text-white">↩</span>
            </div>
            
            <h2 className="text-2xl font-bold text-white mb-4">Payment Cancelled</h2>
            
            <p className="text-white/70 mb-6">
              Your payment has been cancelled. No charges have been made to your account.
              You can continue shopping or try the payment process again.
            </p>

            <div className="flex gap-4 justify-center">
              <Link to="/cart">
                <Button className="bg-gradient-to-r from-blue-500 to-purple-500   text-white">
                  Return to Cart
                </Button>
              </Link>
              <Link to="/dashboard">
                <Button variant="outline" className="border-white/50 text-white bg-white/10">
                  Continue Shopping
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;